import { useFormContext, Controller } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

type RHFTextFieldProps = TextFieldProps & {
  name: string;
  readonly?: boolean;
};

export const RHFTextField = ({ name, readonly, ...other }: RHFTextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={
            field.value === null || field.value === undefined
              ? ''
              : typeof field.value === 'number' && field.value === 0
                ? ''
                : field.value
          }
          error={!!error}
          helperText={error?.message}
          {...other}
          InputProps={{ readOnly: readonly }}
        />
      )}
    />
  );
};

